import * as React from 'react'

export function ConfigsPage() {

  // ---------------------------------------------
  // Transformations
  // ---------------------------------------------
  // Render

  return (
    <div className={'configs-page'}>
      Configurações
    </div>
  )
}